<template>
    <form
        class="flex flex-wrap border border-gray-200 rounded py-3 px-4"
        @submit.prevent="savePermission"
    >
        <div class="lg:w-1/2 md:w-full">
            <div class="flex p-8 flex-col mb-3">
                <div class="field w-full px-3 mb-3">
                    <JetLabel class="w-full" for="name" value="Name" />
                    <Input
                        id="name"
                        v-model="form.name"
                        type="text"
                        placeholder=""
                        class="mt-1 block w-full"
                        :class="{ 'p-invalid': form.errors.name }"
                    />
                    <InputError :message="form.errors.name" class="mt-2" />
                </div>
                <div class="field w-full px-3 mb-3">
                    <JetLabel class="w-full" for="title" value="Title" />
                    <Input
                        id="title"
                        v-model="form.title"
                        type="text"
                        placeholder=""
                        class="mt-1 block w-full"
                        :class="{ 'p-invalid': form.errors.title }"
                    />
                    <InputError :message="form.errors.title" class="mt-2" />
                </div>
                <div class="field w-full px-3 mb-3">
                    <JetLabel
                        class="w-full"
                        for="guard_name"
                        value="Guard Name"
                    />
                    <Input
                        id="guard_name"
                        v-model="form.guard_name"
                        type="text"
                        placeholder=""
                        class="mt-1 block w-full"
                        :class="{ 'p-invalid': form.errors.guard_name }"
                    />
                    <InputError
                        :message="form.errors.guard_name"
                        class="mt-2"
                    />
                </div>
            </div>
        </div>
        <div class="lg:w-1/2 md:w-full">
            <div class="flex p-8 flex-col mb-3">
                <div class="flex flex-wrap">
                    <div class="field w-full px-3 mb-3">
                        <JetLabel class="w-full" for="role" value="Role" />
                    </div>
                    <InputError :message="form.errors.roles" class="mt-2" />
                    <div
                        v-for="role in $page.props.role_list"
                        :key="role.id"
                        class="lg:w-1/8 md:w-1/4 pb-4"
                    >
                        <div class="w-full px-3 text-center">
                            <JetLabel :for="role.name" :value="role.name" />
                            <Checkbox
                                :id="'role_' + role.name"
                                v-model="form.roles[role.name]"
                                :binary="true"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="lg:w-full md:w-full">
            <div class="flex flex-col mb-6">
                <div class="w-full px-3 text-center">
                    <InertiaButtonEdit
                        :class="{ 'opacity-25': form.processing }"
                        label="Simpan Data"
                        v-if="form.id"
                    />
                    <InertiaButtonSave
                        :class="{ 'opacity-25': form.processing }"
                        label="Simpan Baru"
                        v-else
                    />
                </div>
            </div>
        </div>
    </form>
</template>
<script>
import { defineComponent } from "vue";
import Checkbox from "primevue/checkbox";
import ButtonSave from "@/Components/ButtonSave";
import JetLabel from "@/Jetstream/Label";
import Input from "@/Components/Input.vue";
import InputError from "@/Components/InputError.vue";
import InertiaButtonSave from "@/Components/InertiaButtonSave.vue";
import InertiaButtonEdit from "@/Components/InertiaButtonEdit.vue";
import Select from "@/Components/Select";
import Alert from "@/Components/Alert";

import InputDataGrid from "@/Components/InputDataGrid";

export default defineComponent({
    props: ["selectedData"],
    components: {
        Checkbox,
        ButtonSave,
        JetLabel,
        Input,
        InputError,
        InertiaButtonSave,
        InertiaButtonEdit,
        Select,
        Alert,
        InputDataGrid,
    },
    data() {
        return {
            form: this.$inertia.form({
                _method: "POST",
                id: null,
                name: null,
                title: null,
                guard_name: null,
                roles: {},
            }),
        };
    },
    mounted() {
        //
        this.preparedAvailRoles();
    },
    watch: {
        // whenever question changes, this function will run
        selectedData(newSelectedData, oldSelectedData) {
            this.resetForm();
        },
    },
    methods: {
        prepareFormRolesData: function () {
            let role_data = [];
            let role_list = this.$page.props.role_list;
            let self = this;
            _.forEach(role_list, function (role) {
                if (self.form.roles[role.name]) {
                    role_data.push({ name: role.name });
                }
            });
            return role_data;
        },
        preparedAvailRoles: function (selected_roles = []) {
            let role_list = this.$page.props.role_list;
            let self = this;
            _.forEach(role_list, function (role) {
                self.form.roles[role.name] = false;
            });

            _.forEach(selected_roles, function (selected_role) {
                if (_.has(self.form.roles, selected_role.name)) {
                    self.form.roles[selected_role.name] = true;
                }
            });
        },
        addItem: function () {
            //
        },
        populateEdit: function (permission) {
            this.form.id = permission.id;
            this.form.name = permission.name;
            this.form.title = permission.title;
            this.form.guard_name = permission.guard_name;
            this.preparedAvailRoles(permission.roles);
        },
        resetForm: function (event) {
            this.form.id = null;
            this.form.name = null;
            this.form.title = null;
            this.form.guard_name = null;
            this.preparedAvailRoles();
            // this.form.reset();
            this.form.clearErrors();
        },
        savePermission: function (event) {
            let self = this;
            this.form.post(route("permission.store"), {
                errorBag: "savePermission",
                preserveScroll: true,
                onSuccess: () => {
                    let form = Object.assign({}, self.form); // COPY OBJECT FROM PROXY
                    form.roles = self.prepareFormRolesData();
                    if (form.id) {
                        self.$emit("changeData", form);
                    } else {
                        self.$emit("loadData");
                        // self.$emit('addData', self.form);
                        self.resetForm();
                    }
                },
                onFinish: () => {
                    //
                },
            });
        },
    },
});
</script>